import React, { useEffect, useState } from "react";

import { resolveMediaUrl } from "@/lib/resolveMediaUrl";
import { cn } from "@/lib/utils";

interface ClientImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  fallbackSrc?: string;
}

/**
 * Simple client-side image with fallback.
 * (Ported from Next.js "ClientImage" usage; React app doesn't need next/image.)
 */
function resolveImgSrc(src: string | undefined): string | undefined {
  if (typeof src !== "string" || !src.trim()) return undefined;
  return resolveMediaUrl(src) ?? src;
}

export default function ClientImage({ fallbackSrc, className, src, ...props }: ClientImageProps) {
  const [currentSrc, setCurrentSrc] = useState<string | undefined>(resolveImgSrc(typeof src === "string" ? src : undefined));

  useEffect(() => {
    setCurrentSrc(resolveImgSrc(typeof src === "string" ? src : undefined));
  }, [src]);

  return (
    <img
      {...props}
      src={currentSrc}
      className={cn(className)}
      onError={(e) => {
        props.onError?.(e);
        if (fallbackSrc && currentSrc !== fallbackSrc) setCurrentSrc(fallbackSrc);
      }}
    />
  );
}


